/* Product dossier presentation upgrades (snippets/product-dossier.liquid).
   The server ships a plain <details> accordion — complete and functional
   without this file. Here we only add: rail scrollspy, tabs behaviour, and
   the quick-facts deep links. Mobile (≤900px) stays native accordion. */
(function () {
  'use strict';
  var desktop = window.matchMedia('(min-width: 901px)');

  function init(root) {
    var style = root.dataset.style;
    var nav = root.querySelector('[data-dossier-nav]');
    var panels = Array.prototype.slice.call(root.querySelectorAll('.dossier__acc'));
    if (!panels.length) return;

    function navLinks() { return Array.prototype.slice.call(nav ? nav.querySelectorAll('a') : []); }
    function mark(id) {
      navLinks().forEach(function (a) {
        a.classList.toggle('is-on', a.getAttribute('href') === '#' + id);
      });
    }

    function enhance() {
      if (!desktop.matches || style === 'accordion') return;
      root.classList.add('dossier--js');
      if (style === 'rail') {
        panels.forEach(function (d) { d.open = true; });
        var spy = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) mark(e.target.id); });
        }, { rootMargin: '-15% 0px -75% 0px' });
        panels.forEach(function (d) { spy.observe(d); });
        // anchors scroll natively; smooth it
        navLinks().forEach(function (a) {
          a.addEventListener('click', function (ev) {
            var t = document.getElementById(a.getAttribute('href').slice(1));
            if (t) { ev.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
          });
        });
      } else if (style === 'tabs') {
        panels.forEach(function (d, i) { d.open = true; d.classList.toggle('is-on', i === 0); });
        mark(panels[0].id);
        navLinks().forEach(function (a) {
          a.addEventListener('click', function (ev) {
            ev.preventDefault();
            var id = a.getAttribute('href').slice(1);
            panels.forEach(function (d) { d.classList.toggle('is-on', d.id === id); });
            mark(id);
          });
        });
      }
    }
    enhance();

    // quick-facts chips (and any other [data-dossier-jump]) open + scroll to a panel
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-dossier-jump]');
      if (!b) return;
      var t = document.getElementById(b.getAttribute('data-dossier-jump'));
      if (!t) return;
      if (style === 'tabs' && desktop.matches && root.classList.contains('dossier--js')) {
        panels.forEach(function (d) { d.classList.toggle('is-on', d === t); });
        mark(t.id);
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        t.open = true;
        t.scrollIntoView({ behavior: 'smooth', block: desktop.matches ? 'start' : 'center' });
      }
    });
  }

  document.querySelectorAll('[data-dossier]').forEach(init);
})();
